import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(18, 8),
  justifyContent: 'center',
  position: 'relative',
  '@keyframes blink': {
    '0%, 50%': { opacity: 1 },
    '51%, 100%': { opacity: 0 },
  },
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(15, 3),
  },
  '& .BSBackgroundImage': {
    position: 'absolute',
    inset: 0,
    zIndex: -2,
  },
  '& .BSOverlay': {
    position: 'absolute',
    inset: 0,
    zIndex: -1,
    background: `linear-gradient(
    180deg, rgba(235, 242, 237, 0.10) 0%,
    rgba(235, 242, 237, 0.10) 100%),
    rgba(235, 242, 237, 0.80)`,
  },
  '& .BSContent': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  '& .BSFirstHeading': {
    textAlign: 'center',
    color: theme.palette.secondary.main,
    whiteSpace: 'nowrap',
    width: 'fit-content',
    '& .cursor': {
      color: theme.palette.secondary.main,
      fontWeight: 'normal',
    },
    '& .cursor.blink': {
      animation: 'blink 1s infinite',
    },
    [theme.breakpoints.down('lg')]: {
      fontSize: theme.typography.pxToRem(32),
    },
    [theme.breakpoints.down('md')]: {
      whiteSpace: 'normal',
      width: '100%',
    },
  },
  '& .BSSecondHeading': {
    textAlign: 'center',
    fontSize: theme.spacing(8),
    fontWeight: 700,
    color: theme.palette.text.alternate,
    whiteSpace: 'nowrap',
    width: 'fit-content',
    [theme.breakpoints.down('lg')]: {
      fontSize: theme.typography.pxToRem(44),
    },
    [theme.breakpoints.down('md')]: {
      fontSize: theme.typography.pxToRem(36),
      whiteSpace: 'normal',
    },
  },
}));

export default StyledBox;
